<div class="section-label">
  <div class="review_edit-area">
    <div *ngIf="reviewState === reviewStates.ReadOnly">
      <app-icon-button icon="edit" label="EDIT" (click)="editDetails()"></app-icon-button>
    </div>
    <div *ngIf="reviewState === reviewStates.Edit">
      <a (click)="close()" class="buttonLink" mat-button target="_blank">Close</a>
    </div>
  </div>
</div>
<div>
  <div *ngIf="!showPromocodeSection && reviewState === reviewStates.Initial">
    <app-icon-button (click)="onClickOfAdd()" icon="add_circle" label="I have a Promo code"></app-icon-button>
  </div>
  <div *ngIf="showPromocodeSection || reviewState === reviewStates.ReadOnly">
    <h2>Promo code</h2>
  </div>
  <div *ngIf="appliedPromoCodeList.length === 0 && reviewState === reviewStates.ReadOnly">
    <mat-label class="applied-promo-codes"> No promo code applied</mat-label>
  </div>
  <div *ngIf="showPromocodeSection">
    <div style="float: right">
      <app-delete-icon-button icon="cancel" label="CANCEL" (click)="onClickOfCancel()"></app-delete-icon-button>
    </div>
    <p>Enter your promotional code. You can only apply an offer code once.</p>
  </div>
  <div *ngIf="showPromocodeSection">
    <div *ngIf="reviewState !== reviewStates.ReadOnly" fxLayout="row" fxLayout.xs="column" fxLayoutGap="20px">
      <div fxLayout="column" fxLayoutAlign="end start">
        <form [formGroup]="promoCodeForm">
          <mat-form-field appearance="outline">
            <input #promotionalCode (keydown.space)="$event.preventDefault()" formControlName="promoCode" id="promoCode"
                   matInput maxlength="20"
                   required>
          </mat-form-field>
          <mat-label *ngIf="this.promoCodeErrorMessage!" class="applied-promo-codes"
                     style="color: red">{{this.promoCodeErrorMessage}}</mat-label>
        </form>
      </div>
      <div fxLayout="column" fxLayoutAlign="start">
        <a (click)="onClickOfApply(promotionalCode.value!)" class="applyLink" mat-button style="margin-top: 5px"
           target="_blank">
          APPLY CODE
        </a>
      </div>
    </div>
  </div>
  <div fxLayout="column">
    <div>
      <div #selectedPromocode *ngFor="let promocode of appliedPromoCodeList">
        <mat-icon aria-hidden="false" class="promocode-check-mat-icon" id="check">check</mat-icon>
        <mat-label class="applied-promo-codes">{{promocode.promoCodeMessage}}</mat-label>
      </div>
    </div>
  </div>
</div>

